
export default [
  {
    name: 'business',
    path: '/business',
    meta: {
      title: '业务套餐',
      icon: 'shezhi'
    }
  },
  {
    name: 'businessList',
    path: '/business/list',
    meta: { title: '套餐列表' }
  },
  {
    name: 'businessView',
    path: '/business/view',
    meta: { title: '预览套餐' }
  }
]
